import { createClient } from '@supabase/supabase-js';

// Staging vs Production: detectam dupa hostname (web). Pe native folosim env la build.
const isStagingHost = typeof window !== 'undefined'
  && window.location?.hostname
  && window.location.hostname.includes('staging');

const PROD_SUPABASE_URL = 'https://ycajwmrgtmvokvwbhkxl.supabase.co';
const PROD_SUPABASE_ANON = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InljYWp3bXJndG12b2t2d2Joa3hsIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzMyMjcxMjksImV4cCI6MjA4ODgwMzEyOX0.DO0Lk1E4qWK87QDPbEu0_cwRBJD6jTzMUTHSfyogIaE';

const STAGING_SUPABASE_URL = 'https://vbalzoijvfldogctpyts.supabase.co';
const STAGING_SUPABASE_ANON = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InZiYWx6b2lqdmZsZG9nY3RweXRzIiwicm9sZSI6ImFub24iLCJpYXQiOjE3Nzg3NTE4NzcsImV4cCI6MjA5NDMyNzg3N30.1zsS8xZvSaMvpiC_hR_3FVQsmOYaEZHjWkl-Uh29ut0';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL
  || (isStagingHost ? STAGING_SUPABASE_URL : PROD_SUPABASE_URL);
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY
  || (isStagingHost ? STAGING_SUPABASE_ANON : PROD_SUPABASE_ANON);

// Detectare Capacitor native
let _isNativePlatform = false;
try {
  const { Capacitor } = require('@capacitor/core');
  _isNativePlatform = Capacitor?.isNativePlatform() ?? false;
} catch { /* not native */ }

// Singleton — o singură instanță în toată aplicația
let _supabase = null;

function getSupabaseClient() {
  if (_supabase) return _supabase;
  _supabase = createClient(supabaseUrl, supabaseAnonKey, {
    auth: {
      autoRefreshToken: true,
      persistSession: true,
      // Pe native gestionăm manual deep link-ul prin Capacitor appUrlOpen
      detectSessionInUrl: !_isNativePlatform,
    }
  });
  return _supabase;
}

export const supabase = getSupabaseClient();
